import React, { ReactElement } from 'react';

export interface UserStaticInfoProps {
  [attribute: string]: string;
}

let initialUserStaticInfo: UserStaticInfoProps = {};

export const UserStaticInfoContext = React.createContext<UserStaticInfoProps>(
  initialUserStaticInfo,
);

export interface UserStaticInfoProviderProps {
  children?: ReactElement;
  store: {
    [attribute: string]: string;
  };
}
const UserStaticInfoProvider: React.FC<UserStaticInfoProviderProps> = ({
  children,
  store,
}) => {
  return (
    <UserStaticInfoContext.Provider value={store}>
      {children}
    </UserStaticInfoContext.Provider>
  );
};

export default UserStaticInfoProvider;
